import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './../assets/main-icon-white.png'


const _withScopeId = n => (_pushScopeId("data-v-978d475c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "LoginForm-background container-fluid" }
const _hoisted_2 = { class: "row justify-content-center align-items-center h-100" }
const _hoisted_3 = { class: "col-8 col-xs-8 col-sm-8 col-md-6 col-lg-5 col-xl-4" }
const _hoisted_4 = { class: "LoginForm-panel" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "LoginForm-name col-10" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "LoginForm-logo" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "icon",
      class: "MainMenu-icon"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "LoginForm-title" }, "Opti-Loading")
  ])
], -1))
const _hoisted_6 = { class: "row justify-content-center align-items-center" }
const _hoisted_7 = { class: "LoginForm-form col-8" }
const _hoisted_8 = { class: "LoginForm-main" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "LoginForm-label" }, "Логин", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "LoginForm-label" }, "Пароль", -1))
const _hoisted_11 = {
  key: 0,
  class: "LoginForm-error"
}
const _hoisted_12 = { class: "LoginForm-footer" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dx-button-text" }, "Войти", -1))
const _hoisted_14 = {
  key: 0,
  href: "mailto:ashabaev@opti-soft.ru?subject=Запрос демо-доступа к системе Opti-Loading",
  class: "LoginForm-demoText"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxRequiredRule = _resolveComponent("DxRequiredRule")!
  const _component_DxValidator = _resolveComponent("DxValidator")!
  const _component_DxTextBox = _resolveComponent("DxTextBox")!
  const _component_DxCheckBox = _resolveComponent("DxCheckBox")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_DxButton = _resolveComponent("DxButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("form", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", null, [
                  _hoisted_9,
                  _createVNode(_component_DxTextBox, {
                    class: "LoginForm-textbox",
                    stylingMode: "outlined",
                    placeholder: "Введите логин...",
                    "show-clear-button": true,
                    value: _ctx.user.username,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.username) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxValidator, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxRequiredRule, { message: "Необходимо ввести логин" })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_10,
                  _createVNode(_component_DxTextBox, {
                    class: "LoginForm-textbox",
                    stylingMode: "outlined",
                    placeholder: "Введите пароль...",
                    mode: "password",
                    "show-clear-button": true,
                    value: _ctx.user.password,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.password) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxValidator, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxRequiredRule, { message: "Необходимо ввести пароль" })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                (_ctx.error)
                  ? (_openBlock(), _createElementBlock("strong", _hoisted_11, _toDisplayString(_ctx.error), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_DxCheckBox, {
                  class: "LoginForm-checkbox",
                  id: "checkbox",
                  value: _ctx.user.rememberMe,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.rememberMe) = $event)),
                  text: "Запомнить меня"
                }, null, 8, ["value"]),
                _createElementVNode("div", null, [
                  _createVNode(_component_DxButton, {
                    class: "LoginForm-button",
                    id: "button",
                    type: "default",
                    onClick: _ctx.onLogin,
                    "styling-mode": "outlined"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("span", null, [
                        (_ctx.loading)
                          ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                              key: 0,
                              class: "LoginForm-icon",
                              icon: "circle-notch",
                              spin: ""
                            }))
                          : _createCommentVNode("", true),
                        _hoisted_13
                      ])
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              (_ctx.showMailto)
                ? (_openBlock(), _createElementBlock("a", _hoisted_14, " Запросить демо-доступ к системе "))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}